export default __webpack_public_path__ + "static/media/3d_extrinsic.7e33c6fe.jpg";